<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <DownloadReport/>
    <PageHero image="cr-hero.jpg">
      <TextHeading variant="subtitle">Listening and responding</TextHeading>
      <TextHeading variant="xl">Morrisons Corporate Responsibility Programme 2018/19</TextHeading>
      <BaseButton class="mt-10 text-primary" rounded="full" variant="white" width="small">
        <BaseIcon name="arrow_downward" size="22"></BaseIcon>
      </BaseButton>
    </PageHero>
    <PageGrid>
      <PageMain>
        <PageSection title="Morrisons Corporate Responsibility Stories And Programmes">
          <Cards>
            <CardsCol>
              <CardLink
                title="Morrisons introduce paper carrier bags"
                link="Changing our use of plastics"
                category="Programmes"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Too Good to Waste box launched"
                link="Farming Programme"
                category="Corporate Responsibility Stories"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Quieter hour launched in stores"
                link="Helping Hand"
                category="Programmes"
              ></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
        <PageHighlightArticles
          subtitle="Listening &amp; Responding"
          title="Our ten focus areas"
          focusareas
          gradient
        ></PageHighlightArticles>
        <PageSection title="Morrisons Reports & Policies">
          <Cards cols="4">
            <CardsCol>
              <CardDownload title="Full Annual Report 2018/2019" shape="oval"/>
            </CardsCol>
            <CardsCol>
              <CardDownload title="Corporate Responsibility 2018/2019" shape="rectangle"/>
            </CardsCol>
            <CardsCol>
              <CardDownload title="Modern Slavery Statement" shape="triangle"/>
            </CardsCol>
            <CardsCol>
              <CardDownload title="Gender Pay Report" shape="triangle"/>
            </CardsCol>
          </Cards>
        </PageSection>
        <PageHighlightArticles
          subtitle="Reducing packaging"
          title="Changing our use of plastics"
          textarea="By 2025, all Morrisons branded plastic packaging will be recyclable, reusable or compostable"
          gradient
        ></PageHighlightArticles>
        <PageSectionFluid title="Videos">
          <PageVideos/>
        </PageSectionFluid>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import CardDownload from '../components/CardDownload.vue'
import PageGrid from '../elements/PageGrid.vue'
import CardLink from '../components/CardLink.vue'
import CardsCol from '../elements/CardsCol.vue'
import PageHero from '../components/PageHero.vue'
import TheFooter from '../components/TheFooter.vue'
import Cards from '../elements/Cards.vue'
import PageSection from '../elements/PageSection.vue'
import PageSectionFluid from '../elements/PageSectionFluid.vue'
import PageMain from '../elements/PageMain.vue'
import TextHeading from '../elements/TextHeading.vue'
import DownloadReport from '../components/DownloadReport.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
import PageHighlightArticles from '../components/PageHighlightArticles.vue'
import PageVideos from '../components/PageVideos.vue'
export default {
  name: 'CorporateResponsability',
  components: {
    TheHeader,
    BreadcrumbBar,
    DownloadReport,
    TextHeading,
    PageMain,
    PageSection,
    PageSectionFluid,
    Cards,
    CardLink,
    TheFooter,
    PageHero,
    CardsCol,
    PageGrid,
    CardDownload,
    BaseButton,
    BaseIcon,
    PageHighlightArticles,
    PageVideos
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>